import { createAsyncThunk } from "@reduxjs/toolkit";
import {getPetTitlesStart, getPetTitlesSuccess, getPetTitlesFailure
} from "../reducers/getPetTitlesReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getPetTitles = createAsyncThunk(
    "getPetTitles",
    async (_, thunkAPI) => {
        try {
            thunkAPI.dispatch(getPetTitlesStart());
            const token = Cookies.get("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}api/PetInsurance/GetTitles`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const responseData = await response;

            thunkAPI.dispatch(getPetTitlesSuccess(responseData?.data?.result));

            return responseData;
        } catch (error) {
            thunkAPI.dispatch(getPetTitlesFailure(error.response.data.Message));
            if (error.response && error.response.status === 401) {
                Cookies.remove("token");

                thunkAPI.rejectWithValue({ unauthorized: true });
                await thunkAPI.dispatch(getToken());
            }
            throw error;
        }
    }
);